export default __webpack_public_path__ + "static/media/crown.cda6cfaa.png";